<template>
  <div class="lineBarChart-main">
    <basicsChart
      v-if="option.xAxis.data && option.xAxis.data.length"
      ref="basicsChart"
      :id="id"
      :option="option"
    ></basicsChart>
    <div class="no-data-box" v-else>
      <!--<img :src="'/img/imgs/noDataLight.png'" />-->
      <div>暂无数据</div>
    </div>
  </div>
</template>

<script>
import chartMixin from "./chartMixin";

export default {
  name: "lineBarChart",
  mixins: [chartMixin],
  computed: {
    option() {
      return {
        color: ["#35CFE8", "#CF5EFF", "#52A3FF", "#1A44FF", "#00FF6C", "#FEBF02", "#7243ef"],
        tooltip: {
          trigger: "axis",
        },
        yAxis: {
          type: "value",
        },
        grid: {
          top: 68,
          right: 38,
          bottom: 18,
          left: 38,
          containLabel: true,
        },
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: true, // x轴是否启用
        //     start: 0, // 从哪里开始显示
        //     end: 100, // 到哪里结束显示
        //     height: 20,
        //   },
        // ],
        ...this.simpleOptions,
      };
    },
  },
};
</script>

<style lang="scss">
.lineBarChart-main {
  height: 100%;
  .no-data-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
      color: #888;
      margin-top: 8px;
    }
  }
}
</style>
